import { Flex, Skeleton, SkeletonCircle, Tbody, Td, Tr } from '@chakra-ui/react';

const emptyRows = Array.from(Array.from({ length: 20 }), (_, i) => ({ id: i }));

const TrashDocumentsTableSkeleton = () => {
  return (
    <Tbody>
      {emptyRows.map((row) => {
        return (
          <Tr key={row.id}>
            <Td colSpan={2}>
              <Flex py={2} flexDirection='row' alignItems='center'>
                <SkeletonCircle mr={3} borderRadius={0} />
                <Skeleton height='10px' width='100%' />
              </Flex>
            </Td>
          </Tr>
        );
      })}
    </Tbody>
  );
};

export default TrashDocumentsTableSkeleton;
